import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";

import "../css/CreateMap.css";

import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Autocomplete,
  Circle,
} from "@react-google-maps/api";

import useCustom from "../customHook/customHook";
const constants = require("../configs/constants");

export default function CreateMap(props) {
  const [globalState, setGlobalState] = useCustom();

  const [searchResult, setSearchResult] = useState("");
  const [map, setMap] = useState(null);

  const [center, setCenter] = useState([]);

  const [markers, setMarkers] = useState([]);
  const mapRef = useRef(null);

  const [locationDetail, setLocationDetail] = useState();

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: constants.GOOGLE_MAP_KEY,
    libraries: ["places"],
    region: "th",
  });

  const [place, setPlace] = useState({
    latitude: parseFloat(globalState.current_coors.lat),
    longitude: parseFloat(globalState.current_coors.lng),
    circle: {
      radius: 500,
      options: {
        fillColor: 'blue',
        fillOpacity: 0.35,
        strokeColor: 'red',
        strokeOpacity: 1,
        strokeWeight: 2,
      },
    },
  });

  const destinationRef = useRef();

  const containerStyle = { height: "150px" };

  useEffect(() => {
    if (
      globalState.current_coors &&
      Object.keys(globalState.current_coors).length !== 0 &&
      isLoaded === true
    ) {
      setCenter([globalState.current_coors]);
      setMarkers([globalState.current_coors]);
      setPlace({
        latitude: parseFloat(globalState.current_coors.lat),
        longitude: parseFloat(globalState.current_coors.lng),
        circle: {
          radius: 500,
          options: {
            fillColor: 'blue',
            fillOpacity: 0.35,
            strokeColor: 'red',
            strokeOpacity: 1,
            strokeWeight: 2,
          },
        },
      });
      setGlobalState({
        user_address_location: {
          lng: globalState.current_coors.lng,
          lat: globalState.current_coors.lat,
        },
      });
    }
  }, [globalState.current_coors, isLoaded]);

  useEffect(() => {
    if (markers.length >= 1) {
      setGlobalState({
        user_address_location: { lng: markers[0].lng, lat: markers[0].lat },
      });
      //console.log(center);
      //console.log(markers);

      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        `https://kong.traffy.in.th/fondue-reverse-geo/?action=find&latlng=${markers[0].lat},${markers[0].lng}&limit=1`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          const subdistrict = result.subdistrict || result.sub_district || "";
          const district = result.district || "";
          const province = result.province || "";
          setLocationDetail(
            `${subdistrict} ${district} ${province}`.trim()
          );
          setGlobalState({
            user_address_name: result.address || `ตำบล.${subdistrict} อำเภอ.${district} จังหวัด.${province}`,
          });
        })
        .then(() => {
          setGlobalState({
            user_address_location: { lng: markers[0].lng, lat: markers[0].lat },
          });
        })
        .catch((error) => console.log("error", error));

      /*
      fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${markers[0].lat},${markers[0].lng}&key=${constants.GOOGLE_MAP_KEY}&language=th`, requestOptions)
        .then(response => response.text())
        .then(result => {setLocationDetail(JSON.parse(result).results[0].formatted_address); setGlobalState({ user_address_name: JSON.parse(result).results[0].formatted_address });})
        .then(() => {setGlobalState({user_address_location: { lng: markers[0].lng, lat: markers[0].lat }})})
        .catch(error => console.log('error', error));
        */
    }
  }, [center, markers]);

  const handleMarkerMove = (event) => {
    setMarkers([{ lat: event.latLng.lat(), lng: event.latLng.lng() }]);
    setPlace({
      latitude: parseFloat(event.latLng.lat()),
      longitude: parseFloat(event.latLng.lng()),
      circle: {
        radius: 500,
        options: {
          fillColor: 'blue',
          fillOpacity: 0.35,
          strokeColor: 'red',
          strokeOpacity: 1,
          strokeWeight: 2,
        },
      },
    })
    setGlobalState({
      current_coors: { lng: event.latLng.lng(), lat: event.latLng.lat() },
    });
    map.panTo({ lat: event.latLng.lat(), lng: event.latLng.lng() });
  };

  const handleCenter = () => {
    if (!mapRef.current) return;

    const newPos = mapRef.current.getCenter().toJSON();
    setCenter(newPos);
  };

  const onLoad = React.useCallback(function callback(map) {
    map.setCenter({
      lat: globalState.current_coors.lat,
      lng: globalState.current_coors.lng,
    });
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  function onLoad2(autocomplete) {
    setSearchResult(autocomplete);
  }

  function onPlaceChanged() {
    if (searchResult != null) {
      //variable to store the result
      const place = searchResult.getPlace();

      setMarkers([
        {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      ]);
      setPlace({
        latitude: parseFloat(place.geometry.location.lat()),
        longitude: parseFloat(place.geometry.location.lng()),
        circle: {
          radius: 500,
          options: {
            fillColor: 'blue',
            fillOpacity: 0.35,
            strokeColor: 'red',
            strokeOpacity: 1,
            strokeWeight: 2,
          },
        },
      })
      setGlobalState({
        current_coors: {
          lng: place.geometry.location.lng(),
          lat: place.geometry.location.lat(),
        },
      });
      map.panTo({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
    }
  }

  return isLoaded == true && Object.keys(markers).length !== 0 ? (
    <>
      <span className="location-detail">พื้นที่: {locationDetail}</span>
      <div style={{ marginTop: "10px" }}>
        <Autocomplete onPlaceChanged={onPlaceChanged} onLoad={onLoad2}>
          <input
            type="text"
            class="form-control mb-3"
            id="searchAddressTextBox"
            ref={destinationRef}
            placeholder="พิมพ์เพื่อค้นหาสถานที่"
          />
        </Autocomplete>
      </div>
      <GoogleMap
        onClick={handleMarkerMove}
        mapContainerStyle={containerStyle}
        onDragEnd={handleCenter}
        zoom={15}
        onLoad={onLoad}
        onUnmount={onUnmount}
        options={{
          zoomControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        }}
      >
        {markers.map((marker, index) => (
          <Marker position={marker}>
            {
              //console.log('marker', marker)
              //console.log(place)
            }
          </Marker>
        ))}
        <Circle
          center={{
            lat: place.latitude,
            lng: place.longitude,
          }}
          radius={place.circle.radius}
          options={place.circle.options}
        />
        <></>
      </GoogleMap>
    </>
  ) : (
    <></>
  );
}
